import { useState } from "react";
import axios from "axios";

export default function useMutateData() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState(null)
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://ramsden-admin.fly.dev/api/v1";

    // Get CSRF token from meta tag
    const getCsrfToken = () => {
        return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    };

    const mutate = async (method, endpoint, payload = {}) => {
        setLoading(true);
        try {
            const response = await axios({
                method,
                url: `${API_BASE_URL}/${endpoint}`,
                data: payload,
                headers: {
                    "X-CSRF-Token": getCsrfToken(), // Include CSRF token
                },
                withCredentials: true, // Ensure cookies (session) are sent
            });
            setStatus(response.status);
            return response.data;
        } catch (err) {
            setError(err.message || "An error occurred");
            setStatus(err.response?.status);
            // Re-throw the error with full response data so the caller can access error details
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { mutate, loading, error, status };
}
